import { MONTHS } from "./Month.js";

export const MONTHS_STAR = [...MONTHS, "*"] as const;

/**
 * Includes Month values but also a special value to mean "all months".
 */
export type MonthStar = (typeof MONTHS_STAR)[number];
